import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { isEmpty } from '@utils/validationUtils';

export const initialValues = {
  claimCoverId: '',
  lineId: '',
  lineName: '',
  policyCover: '',
  claimCoverName: '',
  claimCoverExternalCode: '',
  arabicName: '',
  claimCoverPrintingOrder: '',
  claimCoverDescription: '',
};

export const drawerSections: IDynamicFormWidgetSection[] = [
  {
    inputs: {
      lineName: {
        name: 'lineName',
        title: 'Line',
        type: FormFieldType.select,
        placeholder: 'Line',
        value: !isEmpty(initialValues.lineName) ? initialValues.lineName : '',
        disabled: true,
        selectOptions: {},
      },
      policyCover: {
        name: 'policyCover',
        title: 'Policy Cover',
        type: FormFieldType.select,
        placeholder: 'Policy Cover',
        value: isEmpty(initialValues.policyCover)
          ? initialValues.policyCover
          : '',
        required: true,
        selectOptions: {},
      },
      claimCoverName: {
        name: 'claimCoverName',
        title: 'Claim Cover Name',
        type: FormFieldType.text,
        placeholder: 'Claim Cover Name',
        value: !isEmpty(initialValues.claimCoverName)
          ? initialValues.claimCoverName
          : '',
        required: true,
      },
      claimCoverExternalCode: {
        name: 'claimCoverExternalCode',
        title: 'External Code',
        type: FormFieldType.text,
        placeholder: 'External Code',
        value: !isEmpty(initialValues.claimCoverExternalCode)
          ? initialValues.claimCoverExternalCode
          : '',
        required: true,
      },
      arabicName: {
        name: 'arabicName',
        title: 'Arabic Name',
        type: FormFieldType.text,
        placeholder: 'Arabic Name',
        value: !isEmpty(initialValues.arabicName)
          ? initialValues.arabicName
          : '',
        required: true,
      },
      claimCoverPrintingOrder: {
        name: 'claimCoverPrintingOrder',
        title: 'Printing Order',
        placeholder: 'Printing Order',
        type: FormFieldType.number,
        value: !isEmpty(initialValues.claimCoverPrintingOrder)
          ? initialValues.claimCoverPrintingOrder
          : [],
        required: true,
      },
      claimCoverDescription: {
        name: 'claimCoverDescription',
        title: 'Description',
        placeholder: 'Description',
        type: FormFieldType.text,
        value: !isEmpty(initialValues.claimCoverDescription)
          ? initialValues.claimCoverDescription
          : [],
        required: true,
      },
    },
  },
];
